import { Route, Switch } from "react-router";
import { Amplify } from "aws-amplify";
import LoginContainer, { LOGIN_URL } from "./routes/login/container/LoginContainer";
import LoggedInLayout from "./layout/LoggedInLayout";
import HomePage, { HOME_URL } from "./routes/HomePage/HomePage";

import { UsersRemovePage } from "./routes/UsersRemovePage";
import { UsersSearchPage } from "./routes/UsersSearchPage";
import { UsersMatchPage } from "./routes/UsersMatchPage";
import { RoommateMatchingReportPage } from "./routes/RoommateMatchingReportPage";

import { PageLayout } from "./layout/PageLayout";
import { URL } from "./constants/navigation";
import { UserReportPage } from "./routes/UserReportPage";
import { GeneralSettingsPage } from "./routes/GeneralSettingsPage";
import { MatchRulesPage } from "./routes/MatchRulesPage";
import { PotentialRoommateFilterPage } from "./routes/PotentialRoommateFilterPage";
import { AdminNotificationsPage } from "./routes/AdminNotificationsPage";
import { UserNotificationsPage } from "./routes/UserNotificationsPage";
import { IntegrationsPage } from "./routes/IntegrationsPage";
import { AdminAccessRequestControlContainer } from "./routes/super_admin/AdminAccessRequestControlContainer";

import "semantic-ui-css/semantic.min.css";
import { NotificationTestContainer } from "./routes/super_admin/NotificationTestContainer";
import { EntrataUsersContainer } from "./routes/super_admin/entrata/EntrataUsers";
import { EntrataMappingContainer, ENTRATA_MAPPING_URL } from "./routes/super_admin/entrata/EntrataMappingContainer";
import { EntrataUserContainer, ENTRATA_USER_URL } from "./routes/super_admin/entrata/EntrataUser";
import { NetworkSettingsContainer } from "./routes/super_admin/network_settings/NetworkSettings";
import { NetworkCreationContainer } from "./routes/super_admin/network_creation/NetworkCreate";
import { TAGS, TagsContainer } from "./routes/super_admin/tags/Tags";
import { PROFILE_PHOTO_JOBS, ProfilePhotoJobs } from "./routes/super_admin/profile_photos/ProfilePhotoJobs";
import { FailureContainer, FAILURE_URL } from "./routes/failure/FailureContainer";
import { OAuthErrorContainer, OAUTH_ERROR_URL } from "./routes/oauthError/OAuthErrorContainer";
import { PrivacyPolicyPage, PRIVACY_POLICY_PAGE_URL } from "./routes/PrivacyPolicyPage";
import { RequestAccessContainer, REQUEST_ACCESS_URL } from "./routes/login/container/RequestAccessContainer";
import { UserPage } from "./routes/UserPage";
import { HowToPage, HOW_TO_PAGE_URL } from "./routes/HowToPage";
import { UsersInvitePage } from "./routes/UsersInvitePage";
import { NetworkSettingsPage } from "./routes/NetworkSettingsPage";
import { PORTFOLIO_LIST, PortfolioList } from "./routes/super_admin/portfolio/PortfolioList";
import { PlacementWorksheetPage } from "./routes/PlacementWorksheetPage";
import {PORTFOLIO_DETAILED, PortfolioDetailedView} from "./routes/super_admin/portfolio/PortfolioDetailedView";
import { SendToEntrataPage } from "./routes/SendToEntrataPage";
import {
  PORTFOLIO_LIFESTYLE_TEMPLATE_DETAILED,
  PortfolioTemplateDetails
} from "./routes/super_admin/portfolio/PortfolioTemplateDetails";
import {
  PORTFOLIO_NETWORK_DETAILED,
  PortfolioNetworkDetails
} from "./routes/super_admin/portfolio/PortfolioNetworkDetails";
import {IS_STAGING} from "./constants/general";
import {getAppConfig} from "./AppConfig";
import { ChatBubble } from "./components/ChatBubble/ChatBubble";
import { ScrollToTop } from "./components/ScrollToTop";

let userPoolId = IS_STAGING ? "us-east-1_pxxyMIJ8g": "us-east-1_AkgEnudfI";
let userPoolWebClientId = IS_STAGING ? "2d50ib1chs2chehal4pgdmmdqr" : "1f4f0i4m5cb9ghfmmurnhle7ks";
let appConfig = getAppConfig();


Amplify.configure({
  Auth: {
    region: "us-east-1", // (required) - Region where Amazon Cognito project was created
    userPoolId: userPoolId, // (optional) -  Amazon Cognito User Pool ID
    userPoolWebClientId: userPoolWebClientId,
    oauth: {
      domain: appConfig.cognitoDomain,
      scope: ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
      redirectSignIn: appConfig.signInUrl,
      redirectSignOut: appConfig.signOutUrl,
      clientId: appConfig.googleClientId,
      responseType: "code",
    },
  },
});

const App = () => {
  return (
    <PageLayout>
      <ScrollToTop />
      <Switch>
        <Route exact component={LoginContainer} path={LOGIN_URL} />
        <Route exact component={FailureContainer} path={FAILURE_URL} />
        <Route exact component={OAuthErrorContainer} path={OAUTH_ERROR_URL} />
        <Route exact component={PrivacyPolicyPage} path={PRIVACY_POLICY_PAGE_URL} />
        <Route exact component={RequestAccessContainer} path={REQUEST_ACCESS_URL} />

        <LoggedInLayout>
          <Route exact component={HomePage} path={HOME_URL} />

          <Route exact path={URL.USERS_INVITE} component={UsersInvitePage} />
          <Route exact path={URL.USERS_SEARCH} component={UsersSearchPage} />
          <Route exact path={URL.USERS_REMOVE} component={UsersRemovePage} />
          <Route exact path={URL.USERS_MATCH} component={UsersMatchPage} />
          <Route exact path={URL.PLACEMENT_WORKSHEET} component={PlacementWorksheetPage} />

          <Route exact path={URL.ROOMMATE_MATCHING_REPORT} component={RoommateMatchingReportPage} />
          <Route exact path={URL.USER_REPORT} component={UserReportPage} />

          <Route path={URL.GENERAL_SETTINGS_BASE} component={GeneralSettingsPage} />
          <Route path={URL.MATCH_RULES_BASE} component={MatchRulesPage} />
          <Route path={URL.PROFILE_BASE} component={PotentialRoommateFilterPage} />

          <Route exact path={URL.DAILY_ACTIVITY_REPORT} component={AdminNotificationsPage} />
          <Route exact path={URL.USER_NOTIFICATIONS} component={UserNotificationsPage} />
          <Route exact path={URL.NETWORK} component={NetworkSettingsPage} />
          <Route exact path={URL.INTEGRATIONS} component={IntegrationsPage} />
          <Route exact path={URL.SEND_TO_ENTRATA} component={SendToEntrataPage} />

          <Route exact component={TagsContainer} path={TAGS} />
          <Route exact path={URL.ADMIN_ACCESS_REQUEST_CONTROL} component={AdminAccessRequestControlContainer} />
          <Route exact path={URL.PUSH_TEST} component={NotificationTestContainer} />
          <Route exact path={URL.ENTRATA} component={EntrataUsersContainer} />
          <Route exact path={ENTRATA_MAPPING_URL} component={EntrataMappingContainer} />
          <Route exact path={ENTRATA_USER_URL} component={EntrataUserContainer} />
          <Route exact path={URL.NETWORK_SETTINGS} component={NetworkSettingsContainer} />
          <Route exact path={URL.NETWORK_CREATION} component={NetworkCreationContainer} />
          <Route exact path={PORTFOLIO_LIFESTYLE_TEMPLATE_DETAILED} component={PortfolioTemplateDetails} />
          <Route exact path={PORTFOLIO_NETWORK_DETAILED} component={PortfolioNetworkDetails} />
          <Route exact path={PORTFOLIO_DETAILED} component={PortfolioDetailedView} />
          <Route exact path={PORTFOLIO_LIST} component={PortfolioList} />
          <Route exact path={PROFILE_PHOTO_JOBS} component={ProfilePhotoJobs} />

          <Route exact path={URL.USER} component={UserPage} />
          <Route exact path={HOW_TO_PAGE_URL} component={HowToPage} />
        </LoggedInLayout>
      </Switch>
      <ChatBubble />
    </PageLayout>
  );
};

export default App;
